module.exports = __webpack_public_path__ + "static/media/add progress report.a7cc61b8.svg";